export default "__VITE_ASSET__DVRMWBvM__"